<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th># Tarima</th>
          <th>Fecha creación</th>
          <th>Fecha Detallado</th>
          <th>Usuario</th>
          <th>Tienda origen</th>
          <th>Tienda destino</th>
          <th>Tipo</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="tarima in tarima.results"
          v-bind:key="tarima.id"
          @click="rowClick(tarima)"
        >
          <td>{{ tarima.numero }}</td>
          <td>{{ tarima.fecha_creacion | moment("YYYY/MM/DD hh:mm:ss") }}</td>

          <td>{{ tarima.fin_detallado | moment("YYYY/MM/DD hh:mm:ss") }}</td>
          <td>
            <UsuarioEnTablaComponent :current="tarima.usuario" />
          </td>
          <td>
            {{ tarima.tienda_origen_obj.nombre }}
          </td>
          <td>{{ tarima.tienda_destino_obj.nombre }}</td>
          <td
            v-if="
              tarima.salida_e_objeto &&
              tarima.salida_e_objeto.tipo_traslado == 'T'
            "
          >
            TRASLADO
          </td>
          <td
            v-if="
              tarima.salida_e_objeto &&
              tarima.salida_e_objeto.tipo_traslado == 'D'
            "
          >
            DEVOLUCIÓN
          </td>
          <td v-if="!tarima.salida_e_objeto"></td>
          <td class="text-center">
            <span class="badge badge-warning">{{ tarima.estado_str }}</span>
          </td>
          <td class="text-center"></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  props: ["tarima"],
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      currentPage: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-tarima-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-tarima-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
